import { Box, Typography } from '@mui/material';
import { dayjs } from '../../../../utils/dayjs';

import { IParticle } from '../../../../types/particles';
import { NotificationEntity } from '../../../../graphql';
import { theme } from '../../../../theme';
import { FORMATS } from '../../../../constants';
import { Particles } from '../../particles';

export type NotificationDetailProperties = {
  notification: NotificationEntity;
};

export const NotificationDetails = ({
  notification,
}: NotificationDetailProperties): JSX.Element => {
  const particles: IParticle[] = JSON.parse(notification.data || '[]') || [];

  return (
    <Box sx={{ flexGrow: 1, p: 2, height: 'inherit', position: 'relative', overflow: 'auto' }}>
      <Box sx={{ display: 'flex', alignParticles: 'center', mb: 1 }}>{notification.title}</Box>
      {notification.description && (
        <Typography fontWeight={500} color={theme.palette.grey[500]} sx={{ mb: 1 }}>
          {notification.description}
        </Typography>
      )}
      <Typography
        variant="subtitle2"
        fontWeight={500}
        color={theme.palette.grey[500]}
        sx={{ mb: 1 }}
      >
        {dayjs(notification.createdAt).format(FORMATS.DATE)} (
        {dayjs().to(dayjs(notification.createdAt))})
      </Typography>

      <Particles particles={particles} />
    </Box>
  );
};
